import { useDispatch } from 'react-redux';
import { getCart } from '../../../../../../../reducers/cart';
import qualityEvents from '../../../../../../../services/quality-events/quality-events';
import { useAppSelector } from '../../../../../../../store';
import { AdyeConfig } from '../../../../../../../api/payment/get-payment-options';
import { PAYMENT_METHOD_KEYS } from '../../../../../payment.constants';
import { resetErrors, validateForm } from '../../../../../reducers';
import usePaymentOptions from '../../../../../../../services/payment/use-payment-options';
import AdyenBtn from '../../adyen-button';

const ApplePayBtn = () => {
    const { paymentCart } = useAppSelector((state: RootState) => state.payment);
    const currency = useAppSelector((state: RootState) => state.main.currency);
    const { data: paymentOptionsData } = usePaymentOptions(currency.code);
    const user = useAppSelector((state: RootState) => state.main.user);
    const merchantData = paymentOptionsData?.adyen.filter((adyenData: AdyeConfig) => adyenData.type === 'applepay');
    const dispatch = useDispatch();
    const onButtonClicked = (resolve: () => void, reject: () => void) => {
        dispatch(getCart());
        dispatch(resetErrors());

        const isInvoiceFormValid = dispatch(validateForm());

        if (!isInvoiceFormValid) {
            reject();
        } else {
            qualityEvents.checkoutPage.startPayment(user.id, PAYMENT_METHOD_KEYS.APPLE_PAY, paymentCart?.finalPrice);

            resolve();
        }
    };
    const config = {
        configuration: {
            merchantName: merchantData && merchantData[0]?.configuration.merchantName,
            merchantId: merchantData && merchantData[0]?.configuration.merchantId
        },
        buttonType: 'buy',
        onClick: onButtonClicked
    };

    return (
        <AdyenBtn
            paymentType='applepay'
            paymentMethodConfiguration={config}
        />
    );
};

export default ApplePayBtn;
